'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _StatisticsCoverageTabs = require('components/Statistics/StatisticsCoverageTabs/StatisticsCoverageTabs');

var _StatisticsCoverageTabs2 = _interopRequireDefault(_StatisticsCoverageTabs);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _statistics = require('helpers/statistics');

var _CoverageChart = require('components/Statistics/CoverageChart/CoverageChart');

var _CoverageChart2 = _interopRequireDefault(_CoverageChart);

var _CoverageRecipientsListWrapper = require('containers/Statistics/CoverageRecipientsListWrapper/CoverageRecipientsListWrapper');

var _CoverageRecipientsListWrapper2 = _interopRequireDefault(_CoverageRecipientsListWrapper);

var _SimpleTabContent = require('components/SimpleTabContent/SimpleTabContent');

var _SimpleTabContent2 = _interopRequireDefault(_SimpleTabContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./StatisticsCoverage.scss');

var notAccessedListColumns = [_statistics.coverageRecipientsColumns.recipientId, _statistics.coverageRecipientsColumns.fullName, _statistics.coverageRecipientsColumns.email, _statistics.coverageRecipientsColumns.expiryDate];

var playedListColumns = [_statistics.coverageRecipientsColumns.fullName, _statistics.coverageRecipientsColumns.email, _statistics.coverageRecipientsColumns.downloaded, _statistics.coverageRecipientsColumns.expiryDate, _statistics.coverageRecipientsColumns.details, _statistics.coverageRecipientsColumns.info];

var StatisticsCoverage = (_class = (_temp = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(StatisticsCoverage, _PureComponent);

  function StatisticsCoverage() {
    var _ref;

    (0, _classCallCheck3.default)(this, StatisticsCoverage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = StatisticsCoverage.__proto__ || (0, _getPrototypeOf2.default)(StatisticsCoverage)).call.apply(_ref, [this].concat(args)));

    _this.state = { activeTab: _statistics.coverageTabs.played };
    return _this;
  }

  (0, _createClass3.default)(StatisticsCoverage, [{
    key: 'onTabClick',
    value: function onTabClick(tab) {
      this.setState({ activeTab: tab });
      this.props.onTabClick(tab);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          id = _props.id,
          data = _props.data,
          loading = _props.loading,
          projectId = _props.projectId;
      var activeTab = this.state.activeTab;


      return _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)(className) },
        _react2.default.createElement(_StatisticsCoverageTabs2.default, {
          activeTab: activeTab,
          tabClass: styles.tab,
          onClick: this.onTabClick
        }),
        _react2.default.createElement(
          _SimpleTabContent2.default,
          null,
          activeTab === _statistics.coverageTabs.played && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_CoverageChart2.default, {
              className: styles.chart,
              id: id,
              data: data.stats
            }),
            _react2.default.createElement(_CoverageRecipientsListWrapper2.default, {
              className: 'margin-top-20',
              recipients: data.playedRecipients,
              columns: playedListColumns,
              loading: loading,
              projectId: projectId
            })
          ),
          activeTab === _statistics.coverageTabs.notAccessed && _react2.default.createElement(_CoverageRecipientsListWrapper2.default, {
            recipients: data.notAccessedRecipients,
            columns: notAccessedListColumns,
            loading: loading,
            showLoader: true,
            projectId: projectId
          })
        )
      );
    }
  }]);
  return StatisticsCoverage;
}(_react.PureComponent), _class2.propTypes = {
  className: _propTypes2.default.string,
  data: _propTypes2.default.object,
  id: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  onTabClick: _propTypes2.default.func,
  projectId: _propTypes2.default.number
}, _class2.contextTypes = {
  t: _propTypes2.default.func
}, _class2.defaultProps = {
  data: {},
  onTabClick: _noop3.default
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onTabClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onTabClick'), _class.prototype)), _class);
exports.default = StatisticsCoverage;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Statistics/StatisticsCoverage/StatisticsCoverage.js
// module id = 2122
// module chunks = 1